import React, { useEffect, useState } from "react";
import { Stack } from "expo-router";

import { LoadingScreen } from "@/blocks/LoadingScreen";
import { ScreenLayout } from "@/blocks/ScreenLayout";
import { VnBox } from "@/components/VnBox";
import { VnLink } from "@/components/VnLink";
import { VnText } from "@/components/VnText/VnText";

export default function NotFoundScreen() {
  const [isLoading, setLoading] = useState(true);

  useEffect(() => {
    const loadingTimeout = setTimeout(() => {
      setLoading(false);
    }, 2000);

    return () => clearTimeout(loadingTimeout);
  }, []);

  return (
    <>
      <Stack.Screen options={{ title: "Oops!" }} />
      <ScreenLayout>
        {isLoading ? (
          <LoadingScreen />
        ) : (
          <VnBox className="gap-2">
            <VnText i18nKey="native:notFound.description" />
            <VnLink href="/" i18nKey="native:notFound.cta" />
          </VnBox>
        )}
      </ScreenLayout>
    </>
  );
}
